import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import {
  Avatar,
  Button,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import PasswordOutlinedIcon from "@mui/icons-material/PasswordOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import PeopleAltSharpIcon from "@mui/icons-material/PeopleAltSharp";

import { selectItem } from "../../store/layoutDashboard/layoutSlice";
import { logout, openModalChangePassword } from "../../store/auth/authSlice";
import { change } from "../../store/language/languageSlice";
import { ModalMenu } from "./ModalMenu";

export const DropdownMenuAppbar = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("global");
  const dispatch = useDispatch();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const { avatar, role, urlDocuments } = useSelector((state) => state.auth);
  const name = avatar.split("-")[0];
  const surnames = avatar.split("-")[1];
  const initialsWords = name[0] + surnames[0];

  const handleOpenMenu = () => {
    setMenuIsOpen(!menuIsOpen);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const changePassword = () => {
    handleClose();
    dispatch(openModalChangePassword());
  };

  const finishSession = () => {
    try {
      window.flutter_inappwebview.callHandler("notifications");
      dispatch(logout());
    } catch (error) {
      dispatch(logout());
    }
  };

  const goTo = (url) => {
    dispatch(selectItem(""));
    navigate(url);
    handleClose();
  };

  const onTranslate = (language) => {
    i18n.changeLanguage(language);
    dispatch(change());
    handleClose();
  };

  const goMyDocuments = () => {
    window.open(urlDocuments, "_blank");
    handleClose();
  };

  return (
    <>
      <ModalMenu menuIsOpen={menuIsOpen} setMenuIsOpen={setMenuIsOpen} />
      <Toolbar>
        <Stack flexDirection="row" justifyContent="space-between" width="100%">
          <IconButton
            onClick={handleOpenMenu}
            size="small"
            edge="start"
            color="secondary"
          >
            <MenuIcon />
          </IconButton>

          <Link to="/">
            <img
              height={40}
              width="auto"
              src="/logo-navbar.png"
              alt="logo faraday"
            />
          </Link>

          <Button
            onClick={handleClick}
            size="small"
            edge="end"
            color="secondary"
            sx={{ gap: 1 }}
          >
            <Avatar {...stringAvatar(initialsWords)} />
            <KeyboardArrowDownIcon />
          </Button>
        </Stack>

        <Menu
          elevation={10}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{ zIndex: 9999 }}
        >
          <MenuItem
            onClick={() => goTo("/myprofile")}
            sx={{ gap: 2, color: "#001B60" }}
          >
            <AccountCircleSharpIcon color="primary" />
            {t("navbarLayout.profile")}
          </MenuItem>
          {role !== "Admin" && (
            <MenuItem
              onClick={() => goTo("/companies")}
              sx={{ gap: 2, color: "#001B60" }}
            >
              <PeopleAltSharpIcon color="primary" />
              {t("drawer.companies")}
            </MenuItem>
          )}
          {urlDocuments && role !== "Admin" && (
            <MenuItem onClick={goMyDocuments} sx={{ gap: 2, color: "#001B60" }}>
              <AssignmentIndIcon color="primary" />
              {t("drawer.documents")}
            </MenuItem>
          )}
          <MenuItem onClick={changePassword} sx={{ gap: 2, color: "#001B60" }}>
            <PasswordOutlinedIcon color="primary" />
            {t("navbarLayout.changePassword")}
          </MenuItem>
          <MenuItem
            onClick={() => onTranslate("es")}
            sx={{ gap: 2, color: "#001B60" }}
          >
            <img src="/es.png" width="27" alt="Bandera España" />
            Español
          </MenuItem>
          <MenuItem
            onClick={() => onTranslate("en")}
            sx={{ gap: 2, color: "#001B60" }}
          >
            <img src="/gb.png" width="28" alt="Bandera Reino Unido" />
            English
          </MenuItem>
          <Divider />
          <MenuItem onClick={finishSession} sx={{ gap: 2, color: "#001B60" }}>
            <ExitToAppOutlinedIcon color="primary" />
            {t("navbarLayout.exit")}
          </MenuItem>
        </Menu>
      </Toolbar>
      {!menuIsOpen && (
        <div style={{ backgroundColor: "#F5F5F5", height: "15px" }}></div>
      )}
    </>
  );
};

function stringAvatar(userName) {
  return {
    sx: {
      bgcolor: "#EA7F22",
      width: "32px",
      height: "32px",
      fontSize: "15px",
    },
    children: userName,
  };
}
